<div class="row">
    <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-xs-12">
        <div class="table-container">
            <table mat-table [dataSource]="dataSource">
                <!-- Step 1 Table -->
                <!-- Select All Column used for all payment screen -->

                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <span>
                        <!-- <mat-checkbox (click)="selectAll()">
                            Select All </mat-checkbox> -->
                            
                            <input type="checkbox" (click)="selectAll($event)" style="margin-right:5px">Select All
                        </span>
                    </th>

                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <!-- <mat-checkbox (change)="rowSelect(element)" [checked]='element.checked'> -->
                            <input type="checkbox" (change)="rowSelect(element)" [checked]='element.checked' style="margin-right:5px">
                            <span class="mobileLabel">Account Number </span>
                        <!-- </mat-checkbox> -->
                        <span>{{element.acctNumber}}</span>
                        </span>
                    </td>
                </ng-container>
                <!-- Select All Column used for Principal payment screen -->
                <ng-container matColumnDef="selectAll">
                    <th mat-header-cell *matHeaderCellDef>
                        Select All
                    </th>

                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                                <!-- <mat-checkbox (change)="rowSelect(element)" [checked]='element.checked'> -->
                                <input type="checkbox" (change)="rowSelect(element)" [checked]='element.checked' style="margin-right:5px">
                                <span class="mobileLabel">Account Number </span>
                        <!-- </mat-checkbox> -->
                        <span>{{element.acctNumber}}</span>
                        </span>
                    </td>
                </ng-container>
                <!-- Current Due Column used for Online payment screen -->
                <ng-container matColumnDef="currentDue">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"><span class="body_required">*</span> Current Due <br/><span style="margin-left: 20px">(xxxxxx.xx)</span> </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel"><span class="body_required">*</span>Current Due <br/><span style="margin-left: 20px">(xxxxxx.xx)</span></span>
                        <span>
                                    $ <input #myInput1 type="text" maxlength="12" style="width:115px;" [(ngModel)]='element.paymentDueAmount' (keypress)="validateDecimal($event,element.paymentDueAmount,element,'online')" (focusout)="convertToDecimal(element)" (click)="replaceCommas(element)"/>
                               
                                    <img src="static/assets/images/required_box.gif" alt="" style="margin-left:5px;" *ngIf="(submitted  &&  (element.currentDueError)) ||(submitted && element.amountLimit) || (submitted && element.emptyAmount)">
                             </span>

                        </span>
                    </td>
                </ng-container>
                <!-- Regular Due Column used for Online payment screen -->
                <ng-container matColumnDef="RegularDue">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Regular Due </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Regular Due</span> <span>{{element.regularAmount  | currency:''}}</span></span>
                    </td>
                </ng-container>

                <!-- Payment Date Column used for Online payment screen -->
                <ng-container matColumnDef="paymentDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> <span class="body_required">*</span>Payment Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel"><span class="body_required">*</span>Payment Date</span>
                        <span>
                        <div class="datestyle">
                        <mat-datepicker  #picker ></mat-datepicker>
                        <input [matDatepicker]="picker" [(ngModel)]="element.paymentDate" (dateInput)="addEvent(element, $event)" style="width:1px;visibility:hidden;">
                        <input class="dateInput lblBlk" size="1" maxlength="2" [(ngModel)]="element.paymentMonth" (change)="onChangePaymentDate($event,element,'month')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <input class="dateInput lblBlk" size="1" maxlength="2" [(ngModel)]="element.paymentDay"  (change)="onChangePaymentDate($event,element,'day')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <input class="dateInput lblBlk" size="2" maxlength="4" [(ngModel)]="element.paymentYear" (change)="onChangePaymentDate($event,element,'year')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <mat-datepicker-toggle [for]="picker">
                            <img matDatepickerToggleIcon src="static/assets/images/wb-calendar.gif">
                        </mat-datepicker-toggle>
                    
                    <img src="static/assets/images/required_box.gif" alt="" *ngIf="submitted && (element.paymentDateError) || (submitted && (element.dueDateError)) ||(submitted && element.wrongDate) || (submitted && element.onePaymentBoolean) || (submitted && element.emptyDate)">
                </div>   
                </span></span>
                    </td>
                </ng-container>

                <!-- Payment Date Column used Principal payment screen -->
                <ng-container matColumnDef="principalPaymentDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> <span class="body_required">*</span>Payment Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel"><span class="body_required">*</span>Payment Date</span>
                        <span>
                                <div class="datestyle">
                        <mat-datepicker  #picker ></mat-datepicker>
                        <input [matDatepicker]="picker" [(ngModel)]="element.paymentDate" (dateInput)="addEvent(element, $event)" style="width:1px;visibility:hidden;">
                        <input class="dateInput lblBlk" size="1" maxlength="2" [(ngModel)]="element.paymentMonth" (change)="onChangePaymentDate($event,element,'month')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <input class="dateInput lblBlk" size="1" maxlength="2" [(ngModel)]="element.paymentDay"  (change)="onChangePaymentDate($event,element,'day')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <input class="dateInput lblBlk" size="2" maxlength="4" [(ngModel)]="element.paymentYear" (change)="onChangePaymentDate($event,element,'year')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                
                        <mat-datepicker-toggle [for]="picker">
                            <img matDatepickerToggleIcon src="static/assets/images/wb-calendar.gif">
                        </mat-datepicker-toggle>
                    
                        <img src="static/assets/images/required_box.gif" alt="" *ngIf="submitted && element.checked && (element.paymentDateError) || (submitted && element.dueDate) || (submitted && element.wrongDate) || (submitted && element.onePaymentBoolean) || (submitted && element.emptyDate)">
                    </div>
                    </span></span>
                    </td>
                </ng-container>
                <!-- Current Due Date Column used for Online payment screen -->
                <ng-container matColumnDef="currentDueDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Current Due Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Current Due Date</span>
                        <span>
                        {{element.currentDueDate | date:'MM/dd/YYYY'}}
                        </span>
                        </span>
                    </td>
                </ng-container>
                <!-- Pay Off Amount column used for online pament screen for payoof feature -->
                <ng-container matColumnDef="payOffAmount">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Pay Off Amount<br/>(xxxxx.xx) </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel"> Pay Off Amount<br/>(xxxxx.xx)</span>
                        <span>
                        {{element.paymentDueAmount | currency:''}}
                        </span>
                        </span>
                    </td>
                </ng-container>
                <!-- Principal Amount Column used for Principal  payment screen -->
                <ng-container matColumnDef="principalAmount">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"><span class="body_required">*</span> Principal Amount
                        <br/><span style="margin-left: 20px">(xxxxxx.xx)</span></th>
                    <td mat-cell *matCellDef="let element">

                        <span class="mobileAlign">
                            <span class="mobileLabel"><span class="body_required">*</span>Principal Amount
                        <br/><span style="margin-left: 20px">(xxxxxx.xx)</span>
                        </span>
                        <span>
                         $ <input #myInput1 type="text" maxlength="12" style="width:115px;" [(ngModel)]='element.paymentDueAmount' (keypress)="validateDecimal($event,element.paymentDueAmount,element,'online')"  (focusout)="convertToDecimal(element)" (click)="replaceCommas(element)"/>
                        <img src="static/assets/images/required_box.gif" alt="" style="margin-left:5px;" *ngIf="(submitted && element.principalAmountError) || (submitted && element.amountLimit) || (submitted && element.emptyAmount)">
                    </span>
                        </span>
                    </td>
                </ng-container>
                <!-- Invoice Number Column used for statement payment screen -->
                <ng-container matColumnDef="invoiceNum">
                    <th mat-header-cell *matHeaderCellDef>
                        <!-- <mat-checkbox (click)="selectAll()"> -->
                        <input type="checkbox" (click)="selectAll($event)" style="margin-right:5px"> Invoice Number
                        <!-- </mat-checkbox> -->
                    </th>
                    <td mat-cell *matCellDef="let element">

                        <span class="mobileAlign">
                            <!-- <mat-checkbox (change)="rowSelect(element)" [checked]='element.checked'> -->
                            <input type="checkbox" (change)="rowSelectforInvoice(element)" [checked]='element.checked' style="margin-right:5px">
                            <span class="mobileLabel">Invoice Number </span>
                        <!-- </mat-checkbox> -->
                        <span>{{element.invoiceNumber}}</span>
                        </span>
                    </td>
                </ng-container>
                <!-- Invoice Date Column used for statement payment screen -->
                <ng-container matColumnDef="invoiceDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Invoice Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Invoice Date </span>
                        <span>{{element.invoiceDate | date:'MM/dd/yyyy'}} </span>
                        </span>
                    </td>
                </ng-container>
                <!-- Invoice Due Date Column used for statement payment screen -->
                <ng-container matColumnDef="invoiceDueDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Invoice Due Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Invoice Due Date </span>
                        <span>{{element.invoiceDueDate}} </span>
                        </span>
                    </td>
                </ng-container>
                <!-- invoiceAmount Column used for statement payment screen -->
                <ng-container matColumnDef="invoiceAmount">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Payable Invoice Amount </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Payable Invoice Amount </span>
                        <span><a href="#"  (click)="onClickInvoiceAmount($event)">{{element.invoiceBalanceAmount | currency:''}}</a></span>
                        </span>
                    </td>
                </ng-container>
                <!--  Amount Column used for Recurring  payment screen -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"><span class="body_required">*</span> Amount </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel"><span class="body_required">*</span>Amount </span>
                        <span> $<input #myInput1 type="text" maxlength="12" style="width:115px;" [(ngModel)]='element.regularAmount' (keypress)="validateDecimal($event,element.regularAmount,element,'recurring')"  (focusout)="convertToRgularDecimal(element)" (click)="replaceCommasForRegular(element)"/>
                                <img   src="static/assets/images/required_box.gif" alt="" style="margin-left:5px;" *ngIf="submitted  && (element.emptyAmount || element.amountError || element.amountLimit)">
                            </span>
                        </span>
                    </td>
                </ng-container>
                <!-- Start Date Column used for Recurring payment screen -->
                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> <span class="body_required">*</span>Start Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel"><span class="body_required">*</span>Start Date</span>
                        <span>
                                <div class="datestyle">
                             <mat-datepicker #picker >  </mat-datepicker>

                             <input [matDatepicker]="picker" [(ngModel)]="element.paymentDate" (dateInput)="addEvent(element, $event)"  style="width:1px;visibility:hidden;">
                             <input class="dateInput lblBlk" size="1" maxlength="2"  [(ngModel)]="element.paymentMonth" (change)="onChangePaymentDate($event,element,'month')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                             <input class="dateInput lblBlk" size="1" maxlength="2"  [(ngModel)]="element.paymentDay" (change)="onChangePaymentDate($event,element,'day')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                             <input class="dateInput lblBlk" size="2" maxlength="4"  [(ngModel)]="element.paymentYear" (change)="onChangePaymentDate($event,element,'year')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">

                             <mat-datepicker-toggle [for]="picker">
                             <img matDatepickerToggleIcon src="static/assets/images/wb-calendar.gif">
                             </mat-datepicker-toggle>
                          
                             <img src="static/assets/images/required_box.gif" alt="" *ngIf="submitted && (element.startDateError || element.startDateError1 || element.emptyDate || element.wrongDate || element.oneDayPayment)  ">
                        </div>  
                        </span>
                        </span>
                    </td>
                </ng-container>
                <!-- End Date Column used for Recurring payment screen -->
                <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> <span class="body_required">*</span>End Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel"><span class="body_required">*</span> End Date</span>
                        <span>
                    <div class="datestyle">
                        <mat-datepicker #picker ></mat-datepicker>
                        <input [matDatepicker]="picker" [(ngModel)]="element.maturityDate" (dateInput)="addEndEvent(element, $event)" style="width:1px;visibility:hidden;">
                        <input class="dateInput lblBlk" size="1" maxlength="2"[(ngModel)]="element.endMonth" (change)="onChangeEndDate($event,element,'month')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <input class="dateInput lblBlk" size="1" maxlength="2" [(ngModel)]="element.endDay" (change)="onChangeEndDate($event,element,'day')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <input class="dateInput lblBlk" size="2" maxlength="4" [(ngModel)]="element.endYear" (change)="onChangeEndDate($event,element,'year')" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                       
                        <mat-datepicker-toggle [for]="picker">
                            <img matDatepickerToggleIcon src="static/assets/images/wb-calendar.gif">
                        </mat-datepicker-toggle>
                   
                        <img src="static/assets/images/required_box.gif" alt="" *ngIf="submitted  && (element.endDateError || element.endDateError2 || element.endDateError4 || element.endDateError3 || element.wrongEndDate || element.emptyEndDate)">
                    </div>
                    </span>
                        </span>
                    </td>
                </ng-container>

                <!-- Step 2 / Step 3 Table -->
                <!-- Account Column used for Online payment and Principal  payment screen -->
                <ng-container matColumnDef="Account">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Account </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Account </span>
                        <span> {{element.acctNumber}} </span>
                        </span>
                    </td>
                </ng-container>
                <!-- Payment Amount Column used for Online payment screen-->
                <ng-container matColumnDef="paymentAmount">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Payment Amount </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Payment Amount </span>
                        <span *ngIf="!step3"> <b>{{element.paymentDueAmount  | currency:''}} </b></span>
                        <span *ngIf="step3"> {{element.paymentDueAmount  | currency:''}} </span>
                        </span>
                    </td>

                </ng-container>

                <!-- Payment Amount Column used for Principal  payment screen-->
                <ng-container matColumnDef="principalPaymentAmount">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Payment Amount </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Payment Amount </span>
                        <span *ngIf="!step3">  <b>{{element.paymentDueAmount | currency:''}}</b></span>
                        <span *ngIf="step3">  {{element.paymentDueAmount | currency:''}}</span>
                        </span>
                    </td>
                </ng-container>
                <!-- Payment Amount Column used for recurring  payment screen-->
                <ng-container matColumnDef="recurringPaymentAmount">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Payment Amount </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Payment Amount </span>
                        <span *ngIf="!step3">  <b>{{element.regularAmount | currency:''}}</b></span>
                        <span *ngIf="step3">  {{element.regularAmount | currency:''}}</span>
                        </span>
                    </td>
                </ng-container>
                <!-- Payment Date Column used for Online Payment and Principal  payment screen-->
                <ng-container matColumnDef="PaymentDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Payment Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Payment Date </span>
                        <span>{{element.paymentDate | date:'MM/dd/yyyy'}} </span>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="recurringStartDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Start Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Start Date </span>
                        <span>{{element.paymentDate | date:'MM/dd/yyyy'}} </span>
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="recurringEndDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> End Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">End Date </span>
                        <span>{{element.maturityDate | date:'MM/dd/yyyy'}} </span>
                        </span>
                    </td>
                </ng-container>

                <!--  Invoice  Number Column used for Statement payment screen-->
                <ng-container matColumnDef="invoiceNumber">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Invoice Number </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Invoice Number </span>
                        <span>  {{element.invoiceNumber }} </span>
                        </span>

                    </td>
                </ng-container>
                <!--  Payment Date Column used for Statement payment screen-->
                <ng-container matColumnDef="statementpaymentDate">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Payment Date </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Payment Date </span>
                        <span>   {{ element.paymentDate| date:'MM/dd/yyyy'}} </span>

                        </span>
                    </td>
                </ng-container>
                <!-- invoiceAmt Column used for statement payment screen -->
                <ng-container matColumnDef="invoiceAmt">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> <span *ngIf="!step3">Payable Invoice Amount</span>
                        <span *ngIf="step3"> Payment Amount</span> </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Payable Invoice Amount </span>
                        <span *ngIf="!step3"><b>{{element.invoiceBalanceAmount | currency:''}}</b></span>
                        <span *ngIf="step3">{{element.invoiceBalanceAmount | currency:''}}</span>
                        </span>
                    </td>
                </ng-container>

                <!--  Transaction ID Column used for Online Payment and Principal  payment screen-->
                <ng-container matColumnDef="transacationId">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Transaction ID </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Transaction ID </span>
                        <span *ngIf="step3" style="color: #0000A0">{{element.transactionId}}</span>
                        </span>
                    </td>
                </ng-container>
                <!-- Status Column used for Online Payment and Principal  payment screen-->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Status </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Status </span>
                        <span *ngIf="step3" style="color: #0000A0">{{element.status}}</span>
                        </span>
                    </td>
                </ng-container>
                <!--  Transaction ID Column used for print screen-->
                <ng-container matColumnDef="printTransacationId">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Transaction ID </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Transaction ID </span>
                        <span *ngIf="step3">{{element.transactionId}}</span>
                        </span>
                    </td>
                </ng-container>
                <!-- Status Column used for print screen-->
                <ng-container matColumnDef="printStatus">
                    <th mat-header-cell *matHeaderCellDef class="mobelHeader"> Status </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="mobileAlign">
                            <span class="mobileLabel">Status </span>
                        <span *ngIf="step3">{{element.status}}</span>
                        </span>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                <hr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
                </tr>

            </table>
        </div>

    </div>
</div>
